import React, { useEffect, useMemo } from 'react';
import { AutocompleteDropdown, Box, Controller, ControllerWrapper, FieldWrapper, FormPreloader, Label, useFormContext, useWatch } from '@common-fe/common-fe';

import { DefaultSortTypesEnum } from '@/common/types';
import { useGetFieldLevelAccessListQuery } from '@/modules/role/queries';
import { IFieldLevelAccessProperties, IPropertiesSection } from '@/modules/role/role.types';

import FieldLevelAccessPropertiesConfirmSetup from '../../FieldLevelAccessSetupConfirmModal/FieldLevelAccessPropertiesConfirmSetup';

interface Props {
  onChangeProperties?: (values: IFieldLevelAccessProperties) => void;
  onChangeOverridableProperties?: (values: IFieldLevelAccessProperties) => void;
}
const SelectAccessLevelProperties: React.FC<Props> = ({
  onChangeProperties,
  onChangeOverridableProperties,
}) => {
  const {
    isLoading,
    data,
    dropdownOptions,
  } = useGetFieldLevelAccessListQuery({
    sortBy: DefaultSortTypesEnum.ASC,
    page: 0,
    perPage: 20,
    searchString: '',
  });
  const {
    control,
    formState: { errors },
  } = useFormContext<IPropertiesSection>();

  const copyLevelAccessId: string = useWatch({
    name: 'copyLevelAccessId'
  });

  const currentItem = useMemo(() => {
    return data?.find((item) => item.id === copyLevelAccessId);
  }, [data, copyLevelAccessId]);

  useEffect(() => {
    if(currentItem) {
      onChangeProperties?.(currentItem?.properties as IFieldLevelAccessProperties);
      onChangeOverridableProperties?.(currentItem?.overridableProperties as IFieldLevelAccessProperties);
    }
  }, [currentItem, onChangeProperties, onChangeOverridableProperties]);
  
  if(isLoading) {
    return (
      <Box margin={{top: 'l'}}>
        <FormPreloader count={1} />
      </Box>
    );
  }

  return (
    <Box
      direction="column"
      round="container1Round"
      background="canvas"
      pad="l"
      border={{ size: 'small', color: 'border1' }}
    >
      <Box direction='column'>
        <FieldWrapper align="center" margin={{ bottom: '' }}>
          <Label showRequireIcon name="level" isNarrow={true}>
            Field level access
          </Label>

          <ControllerWrapper>
            <Controller
              name="copyLevelAccessId"
              control={control}
              render={({ field }) => (
                <Box width={{ max: 'medium' }}>
                  <AutocompleteDropdown
                    errorText={errors?.copyLevelAccessId?.message}
                    name={field.name}
                    placeholder="Field level access"
                    value={field.value} 
                    onChange={(value) => {
                    
                      if(value !== undefined) {
                        field.onChange(value);
                      }
                    }}
                    options={dropdownOptions}
                  />
                </Box>
              )}
            />
          </ControllerWrapper>

        </FieldWrapper>
        {copyLevelAccessId && (
          <Box>
            <FieldLevelAccessPropertiesConfirmSetup
              isSearchLess
              properties={currentItem?.properties}
              overridableProperties={currentItem?.overridableProperties}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SelectAccessLevelProperties;